import { useCallback } from 'react';
import { useAuthStore } from '../stores/auth-store';
import { authenticatedFetch } from '../services/auth-service';
import { TaskEither, taskEither } from '@shared-commons/utils';
import { getFirebaseAuth } from '@/shared/utils';

/**
 * Hook that provides a function to make authenticated API calls with automatic token refresh
 * @returns A function that makes authenticated API calls
 */
export function useAuthenticatedFetch() {
  const { user, setUser } = useAuthStore();

  /**
   * Make an authenticated API call with automatic token refresh
   * @param url The URL to fetch
   * @param options Fetch options (without Authorization header, it will be added automatically)
   * @returns A TaskEither with the fetch response or an error
   */
  const fetchWithAuth = useCallback(
    (url: string, options: RequestInit = {}): TaskEither<Error, Response> => {
      return taskEither(async () => {
        const auth = await getFirebaseAuth();
        return authenticatedFetch(url, options, user, setUser, auth)();
      });
    },
    [user, setUser],
  );

  return { fetchWithAuth };
}
